'use client';

import { create } from 'zustand';
import { fetchLabels, Label } from '@/lib/cloudflare/labels-client';

interface LabelsState {
  labels: Label[];
  isLoading: boolean;
  lastFetched: number | null;
  fetchLabels: () => Promise<void>;
}

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const useLabelsStore = create<LabelsState>((set, get) => ({
  labels: [],
  isLoading: false,
  lastFetched: null,

  fetchLabels: async () => {
    const state = get();

    // Return cached if still fresh
    if (state.lastFetched && Date.now() - state.lastFetched < CACHE_DURATION && state.labels.length > 0) {
      return;
    }

    // Don't fetch if already loading
    if (state.isLoading) return;

    set({ isLoading: true });
    try {
      const { labels } = await fetchLabels();
      set({ labels, lastFetched: Date.now() });
    } catch (error) {
      console.error('Failed to fetch labels:', error);
    } finally {
      set({ isLoading: false });
    }
  },
}));
